<div class="flex flex-col gap-4">
  <app-custom-instructions-form
    [(ngModel)]="customInstruction"
    (ngModelChange)="
      onCustomInstructionChange($event)
    "></app-custom-instructions-form>

  <div class="flex justify-end gap-2">
    <p-button
      label="Cancel"
      [text]="true"
      severity="secondary"
      (click)="handleCancelClick()" />
    <p-button
      label="Ok"
      [outlined]="true"
      severity="primary"
      (click)="handleSaveClick()" />
  </div>
</div>
